<p><b>Funktionen und Features</b></p>
<div [class]="this.addPtgDependencyMode && 'fixed-size-container-300'" class="mini-grid-ptg margin">
    <div class="mikro-grid-ptg">
        <p *ngIf="!isCertification">
            Sollen der Produktversion (weitere) Produkttypen zugeordnet werden?
        </p>
        <p *ngIf="isCertification">
            Sollen der Zertifizierungsversion (weitere) Produkttypen zugeordnet
            werden?
        </p>
        <toggle-switch [trueLabel]="'Ja'" [falseLabel]="'Nein'" [allowUndefined]="false"
            (valueChange)="onToggle($event)">
        </toggle-switch>
    </div>

    <div *ngIf="this.addPtgDependencyMode" [class]="this.addPtgDependencyMode && 'fixed-size-container-240'">
        <div *ngIf="this.ptgWithActiveVersions != undefined">
            <div *ngFor="let ptg of this.ptgWithActiveVersions.ptgList">
                <button id="basic" class="extendWidth" (click)="addPtgVersion(ptg)" mat-button>
                    {{ ptg.name }}
                </button>
            </div>
        </div>
        <mat-paginator style="position: absolute; bottom: 5px; left: 0px; right: 0px"
            [length]="this.ptgWithActiveVersions?.totalNumberOfElements" [pageSize]="5" [pageIndex]="this.pageIndex / 5"
            aria-label="Select page" (page)="pageChanged($event)">
        </mat-paginator>
    </div>
</div>